import * as _ from 'underscore';
import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppConfig} from '../app.config';

@Component({
  selector: 'health-check',
  templateUrl: './health-check.component.html',
  styleUrls: ['./health-check.component.css'],
  host: {
    class: 'col-12',
  },
})

export class HealthCheck implements OnInit {
  public statusObject: string;
  appConfig: AppConfig;

  constructor(private httpClient: HttpClient) {
    this.appConfig = new AppConfig();
  }

  ngOnInit() {
    (async () => {
      const data = await this.httpClient.get(this.appConfig.baseUrl + 'status');
      return data.toPromise().then(res => {
        return this.statusObject = JSON.stringify(res);
      })
    })();
  }
}



// WEBPACK FOOTER //
// ./src/app/health-check/health-check.component.ts